import singleSpaReact from 'single-spa-react';
import type { AppProps } from 'single-spa';
import ReactDOM from 'react-dom';
import React from 'react';

import { loadRuntimeVariables } from '@billing/shared/utils/functions';

const {
    bootstrap: _bootstrap,
    mount,
    unmount,
} = singleSpaReact({
    React,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ...(ReactDOM?.createRoot ? { ReactDOMClient: ReactDOM } : { ReactDOM }),
    loadRootComponent: () => import('./root').then(module => module.default),
    errorBoundary() {
        return null as any;
    },
});

function bootstrap(config: AppProps) {
    return new Promise(loadRuntimeVariables).then(() => _bootstrap(config as never));
}

export { bootstrap, unmount, mount };
